<div class="npdc-title">
  <h1>Plankton taxa</h1>
</div>

<p>
  This is the taxonomic data associated with the
  <a routerLink="/dataset/{{ planktonDatasetId }}"> Marine plankton biodiversity </a>
  dataset.
</p>

<div class="npdc-search">
  <div class="npdc-search__input">
    <div class="npdc-search__input__prefix">
      <mat-icon>search</mat-icon>
    </div>
    <input
      type="search"
      placeholder="Search in taxa …"
      [value]="q()"
      (search)="onSearchEvent($event)"
      (keydown.enter)="onSearchEvent($event)"
    />
  </div>
  <button
    mat-icon-button
    matTooltip="Download …"
    [matMenuTriggerFor]="downloadMenu"
    [disabled]="!response.hasValue() || !response.value().items.length"
  >
    <mat-icon>download</mat-icon>
  </button>
</div>

<app-list [resource]="response">
  @if (!response.error()) {
    <mat-nav-list>
      @for (tax of response.value()?.items; track tax.id) {
        <a mat-list-item routerLink="/plankton/taxon/{{ tax.id }}">
          <mat-icon matListItemIcon>bubble_chart</mat-icon>
          <span matListItemTitle>{{ tax.scientificName }}</span>
          <span matListItemLine>{{ path(tax) }}</span>
          <span matListItemLine>
            @if (tax.occurrenceCount !== null) {
              <span [ngPlural]="tax.occurrenceCount || 0">
                <ng-template ngPluralCase="=0">no occurrence</ng-template>
                <ng-template ngPluralCase="=1">1 occurrence</ng-template>
                <ng-template ngPluralCase="other"
                  >{{ tax.occurrenceCount }} occurrences</ng-template
                >
              </span>
            }
          </span>
        </a>
      }
    </mat-nav-list>

    <mat-paginator
      showFirstLastButtons
      (page)="onPageEvent($event)"
      [length]="count()"
      [pageIndex]="page()"
      [pageSize]="pageSize()"
      [pageSizeOptions]="[10, 20, 50, 100]"
    >
    </mat-paginator>
  }
</app-list>

<mat-menu #downloadMenu>
  <a mat-menu-item href="{{ downloadURL('csv') }}" target="_blank"> Download as csv </a>
</mat-menu>
